export const TAB_LIST_SESSION_KEY = `LAYOUT_TAB_LIST_${window.fe.project ? window.fe.project.toLocaleUpperCase() : ''}`

export const TAB_PAGE_FRAME_STORAGE_KEY = `LAYOUT_PAGE_FRAME`